module.exports = __webpack_public_path__ + "static/media/synctree.d4ad5866.png";